<!-- START Sidebar (left)-->
<!--
  CHAT-857: the Kendo Drawer replaces the Angle nested-<ul> renderer.

  The Drawer takes ONE flat array and rebuilds the hierarchy from id/parentId, so there is
  a single item template for both levels rather than the five hand-copied nesting levels
  that were here before. The `level` from the template context is what separates a
  top-level row from a submenu child - children carry no icon and are indented instead.

  Deliberately absent: the `.sidebar-subnav-header` row. The Angle template printed the
  group's own name above its children, so an expanded group showed its name twice.
-->
<div class="aside-inner">
  <nav
    class="sidebar"
    [class.show-scrollbar]="settings.getLayoutSetting('asideScrollbar')"
    (mouseleave)="scheduleFlyoutClose()"
  >
    <kendo-drawer
      class="sidebar-drawer"
      mode="push"
      [mini]="true"
      [expanded]="isDrawerExpanded"
      [autoCollapse]="false"
      [animation]="false"
      [items]="drawerItems"
      [isItemExpanded]="isItemExpanded"
      (select)="onSelect($event)"
    >
      <!-- The collapse toggle is chrome, not a destination, so it lives in the header
           template rather than becoming a menu item. -->
      <ng-template kendoDrawerHeaderTemplate>
        <button
          type="button"
          class="sidebar-toggle"
          title="Toggle menu"
          aria-label="Toggle menu"
          (click)="toggleCollapsedSideabar($event)"
        >
          <em class="icon-menu"></em>
        </button>
      </ng-template>

      <ng-template
        kendoDrawerItemTemplate
        let-item
        let-isExpanded="isItemExpanded"
        let-hasChildren="hasChildren"
        let-level="level"
      >
        <!-- group parent: toggles, never navigates.

             `data-sidebar-group` carries the item id out to the DOM so
             syncGroupAriaExpanded() can put aria-expanded on the row's <li> — the
             Drawer's own element, which is where focus and role="menuitem" live and
             therefore the only place the state is announced from. The item template
             cannot reach that <li>, which is why this is stamped here and read
             there rather than bound directly (CHAT-911). -->
        <span
          *ngIf="hasChildren"
          class="k-drawer-link sidebar-row sidebar-row-group"
          [class.sidebar-row-active-group]="item.id === activeGroupId"
          [attr.title]="item.text"
          [attr.data-sidebar-group]="item.id"
          (mouseenter)="onRowHover($event, item)"
        >
          <em *ngIf="item.icon" class="sidebar-row-icon {{ item.icon }}"></em>
          <span class="k-item-text sidebar-row-text">{{
            (item.translate | translate) || item.text
          }}</span>
          <em
            class="sidebar-row-toggle"
            aria-hidden="true"
            [class.icon-arrow-up]="isExpanded"
            [class.icon-arrow-down]="!isExpanded"
          ></em>
        </span>

        <!-- external link -->
        <a
          *ngIf="!hasChildren && item.elink"
          class="k-drawer-link sidebar-row"
          [class.sidebar-row-child]="level > 0"
          [attr.href]="item.elink"
          [attr.target]="item.target"
          [attr.title]="item.text"
          (mouseenter)="onRowHover($event, item)"
        >
          <em *ngIf="item.icon" class="sidebar-row-icon {{ item.icon }}"></em>
          <span class="k-item-text sidebar-row-text">{{
            (item.translate | translate) || item.text
          }}</span>
          <span
            *ngIf="item.alert"
            class="sidebar-row-badge"
            [ngClass]="item.label || 'badge badge-success'"
            >{{ item.alert }}</span
          >
        </a>

        <!-- routed leaf, at either level -->
        <a
          *ngIf="!hasChildren && !item.elink && item.link"
          class="k-drawer-link sidebar-row"
          [class.sidebar-row-child]="level > 0"
          [routerLink]="item.link"
          [attr.route]="item.link"
          [attr.title]="item.text"
          (mouseenter)="onRowHover($event, item)"
        >
          <em *ngIf="item.icon" class="sidebar-row-icon {{ item.icon }}"></em>
          <span class="k-item-text sidebar-row-text">{{
            (item.translate | translate) || item.text
          }}</span>
          <span
            *ngIf="item.alert"
            class="sidebar-row-badge"
            [ngClass]="item.label || 'badge badge-success'"
            >{{ item.alert }}</span
          >
        </a>
      </ng-template>
    </kendo-drawer>
  </nav>
</div>

<!-- Collapsed-rail flyout: the rail has no room for inline children, so a hovered group
     shows them here instead. Replaces the jQuery `.nav-floating` clone. -->
<kendo-popup
  *ngIf="flyoutGroup && flyoutAnchor"
  class="sidebar-flyout"
  [anchor]="flyoutAnchor"
  [anchorAlign]="{ horizontal: 'right', vertical: 'top' }"
  [popupAlign]="{ horizontal: 'left', vertical: 'top' }"
  [margin]="{ horizontal: 0, vertical: 0 }"
  [collision]="{ horizontal: 'fit', vertical: 'fit' }"
  [animate]="false"
  (mouseenter)="onFlyoutEnter()"
  (mouseleave)="scheduleFlyoutClose()"
>
  <div class="sidebar-flyout-title">
    {{ (flyoutGroup.translate | translate) || flyoutGroup.text }}
  </div>
  <ul class="sidebar-flyout-list">
    <li
      *ngFor="let child of flyoutGroup.children; trackBy: trackByDrawerItem"
      [class.k-selected]="child.selected"
    >
      <a
        *ngIf="child.elink; else routedChild"
        class="sidebar-flyout-link"
        [attr.href]="child.elink"
        [attr.target]="child.target"
        (click)="closeFlyout()"
        >{{ (child.translate | translate) || child.text }}</a
      >
      <ng-template #routedChild>
        <a
          class="sidebar-flyout-link"
          [routerLink]="child.link"
          (click)="closeFlyout()"
          >{{ (child.translate | translate) || child.text }}</a
        >
      </ng-template>
    </li>
  </ul>
</kendo-popup>
<!-- END Sidebar (left)-->
